import { Link, useLocation } from "react-router-dom";
import { House, Trophy, MagnifyingGlass, Star, User } from "@phosphor-icons/react";
import { useFavorites } from "../contexts/FavoritesContext";
import { useAuth } from "../contexts/AuthContext";

export default function MobileNav() {
  const location = useLocation();
  const { favorites } = useFavorites();
  const { user, login } = useAuth();
  const path = location.pathname;

  const items = [
    { to: "/", icon: House, label: "Home", active: path === "/" },
    { to: "/league/nfl", icon: Trophy, label: "Leagues", active: path.startsWith("/league") },
    { to: "/?tab=favorites", icon: Star, label: "Favorites", active: path === "/" && location.search.includes("favorites"), badge: favorites.length },
  ];

  return (
    <nav className="fixed bottom-9 left-0 right-0 z-40 bg-[#141414] border-t border-white/10 sm:hidden" data-testid="mobile-nav">
      <div className="flex items-center justify-around h-14">
        {items.map((item) => (
          <Link
            key={item.label}
            to={item.to}
            className={`flex flex-col items-center gap-0.5 px-3 py-1 relative ${item.active ? "text-[#007AFF]" : "text-white/40"}`}
            data-testid={`mobile-nav-${item.label.toLowerCase()}`}
          >
            <item.icon size={20} weight={item.active ? "fill" : "regular"} />
            <span className="text-[9px] tracking-wider uppercase font-semibold">{item.label}</span>
            {item.badge > 0 && (
              <span className="absolute -top-0.5 right-1 w-3.5 h-3.5 rounded-full bg-[#007AFF] text-[7px] flex items-center justify-center text-white font-bold">{item.badge}</span>
            )}
          </Link>
        ))}
        {user ? (
          <Link to="/" className="flex flex-col items-center gap-0.5 px-3 py-1 text-white/40" data-testid="mobile-nav-profile">
            {user.picture ? (
              <img src={user.picture} alt="" className="w-5 h-5 rounded-full" />
            ) : (
              <User size={20} />
            )}
            <span className="text-[9px] tracking-wider uppercase font-semibold">Profile</span>
          </Link>
        ) : (
          <button onClick={login} className="flex flex-col items-center gap-0.5 px-3 py-1 text-white/40" data-testid="mobile-nav-signin">
            <User size={20} />
            <span className="text-[9px] tracking-wider uppercase font-semibold">Sign In</span>
          </button>
        )}
      </div>
    </nav>
  );
}
